import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

console.log('[DEBUG NotFoundPage] Component loaded');

// TODO: Consider adding a braai-themed illustration here for brand consistency
const NotFoundPage: React.FC = () => {
  console.log('[DEBUG NotFoundPage] Rendering 404 page');

  return (
    <>
      <Helmet>
        <title>Page Not Found | SpitFire Braai Catering</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '2rem',
        color: '#fff',
        backgroundColor: '#000'
      }}>
        <h1 style={{ fontSize: '4rem', fontWeight: 'bold', color: '#D4752E' }}>404</h1>
        <h2 style={{ marginBottom: '1rem' }}>Page Not Found</h2>
        <p style={{ color: '#999', marginBottom: '2rem' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          style={{
            padding: '0.75rem 2rem',
            backgroundColor: '#D4752E',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '4px',
            fontWeight: 'bold'
          }}
        >
          Back to Home
        </Link>
      </div>
    </>
  );
};

export default NotFoundPage;
